module.exports = __webpack_public_path__ + "static/media/s3.f2484dff.jpg";